import { ref } from "vue";

/**
 * 画面ロジックを扱う composable。
 */
export const useTmpMemberUiState = () => {
  // 画面状態・共通
  const errdialog = ref(false);
  const notdeliverableerrdialog = ref(false);
  const errMessage = ref("");
  const editPage = ref(false);
  const confirmPage = ref(false);
  const panel = ref<number[]>([0]);
  const processFlag = ref(0);
  const overlay = ref(false);
  const displayListSettingDialog = ref(false);
  const displayListSearchDialog = ref(false);

  const onClickListSearch = (): void => {
    displayListSearchDialog.value = true;
  };

  const openListPage = (): void => {
    editPage.value = false;
    confirmPage.value = false;
  };

  const openEditPage = (): void => {
    processFlag.value = 1;
    editPage.value = true;
    confirmPage.value = false;
  };

  const openConfirmPage = (): void => {
    editPage.value = false;
    confirmPage.value = true;
  };

  return {
    errdialog,
    notdeliverableerrdialog,
    errMessage,
    editPage,
    confirmPage,
    panel,
    processFlag,
    overlay,
    displayListSettingDialog,
    displayListSearchDialog,
    onClickListSearch,
    openListPage,
    openEditPage,
    openConfirmPage,
  };
};
